<template>
  <div>
    <v-dialog v-model="dialog" persistent max-width="600px">
      <template v-slot:activator="{ on, attrs }">
        <v-icon size="24px" v-bind="attrs" v-on="on" @click="setData">mdi-magnify</v-icon>
      </template>
      <v-card>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col>
                <div class="d-flex justify-space-between align-center">
                  <span class="headline grey--text text--darken-4">Detalhes do Relatório</span>
                  <v-icon size="24px" class="pointer" @click="dialog = false">
                    mdi-close
                  </v-icon>
                </div>
              </v-col>
            </v-row>
             <v-form ref="form" v-model="valid">
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    label="Nome do relatório"
                    v-model="name"
                    :rules="[rules.required]"
                    disabled
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-select
                    v-model="typeReportSelected"
                    :items="typeReport"
                    item-text="description"
                    item-value="id"
                    label="Tipo de relatório"
                    :rules="[rules.required]"
                    disabled
                  >
                  </v-select>
                </v-col>
                <v-col cols="6">
                    <span class="mr-2 grey--text text--darken-3">Data inicial: </span> 
                    <v-text-field
                        class="mr-4" 
                        type="date" 
                        v-model="dateStart" 
                        :rules="[moment(dateStart).format('yyyy/MM/DD') <= moment().format('yyyy/MM/DD') || 'A data inserida não pode ser maior que a data atual', rules.required]"
                        disabled
                    >
                    </v-text-field> 
                </v-col>
                <v-col cols="6">
                    <span class="mr-2 grey--text text--darken-3">Data final: </span> 
                    <v-text-field
                        v-model="dateEnd" 
                        type="date" 
                        :rules="[moment(dateEnd).format('yyyy/MM/DD') <= moment().format('yyyy/MM/DD') || 'A data inserida não pode ser maior que a data atual', dateStart <= dateEnd || 'A da inical não pode ser maior que a data final', rules.required]"
                        disabled
                    >
                    </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-select
                    multiple
                    v-model="channels"
                    :items="channelList"
                    item-text="name"
                    item-value="id"
                    label="Canais"
                    :rules="[rules.required]"
                    disabled
                  >
                  </v-select>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions class="d-flex justify-center flex-wrap align-center">
            <v-spacer class="d-none d-md-block"></v-spacer>
            <v-btn
                v-if="!deleteConfirm"
                color="#ef5350"
                class="button-primary mb-4"
                @click="deleteConfirm = true"
                dark
            >
                <span>Excluir relatório</span>
            </v-btn>
            <v-btn v-else color="#ef5350" class="mb-4" @click="deleteReport()" dark>
                <span>CONFIRMAR EXCLUSÃO</span>
            </v-btn>
            <v-btn
                :disabled="!valid"
                color="#fed602"
                @click="downloadReport()"
                class="button-primary mb-4 mr-2"
            >
                <v-progress-circular v-if="loading" :indeterminate="true" size="24"></v-progress-circular>
                <span v-else>Fazer Download</span>
            </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  props: {
    report: {
      type: Object,
      required: true,
      default: null,
    }
  },
  computed: {
    dateFormat: function () {
      return this.period ? moment(this.period).format("DD-MM-YYYY") : "";
    },
  },
  data: () => ({
    moment: moment,
    name: "",
    dateEnd: '',
    dateStart: '',
    pickerPeriod: false,
    period: "",
    typeReportSelected: "",
    typeReport: [],
    channels: "",
    channelList: [],
    loading: false,
    notification: {
      active: false,
      description: "",
      type: "",
      closeText: "",
    },
    deleteConfirm: false,
    valid: true,
    rules: {
      required: (value) => !!value || "Este campo é obrigatório.",
      min: (v) =>
        v.length >= 6 || "Sua senha precisa ter pelo menos 6 caracteres",
      email: (v) => /.+@.+\..+/.test(v) || "E-mail inválido",
    },
    dialog: false,
  }),
  methods: {
    setData() {
        this.getReportType();
        this.getChannel();
        this.name = this.report.name;
        this.dateEnd = this.report.end_date;
        this.dateStart = this.report.start_date;
        this.typeReportSelected = this.report.id_report_type;
        this.channels = this.report.channels.map((channel) => {
            return channel.id_youtube_channel
        })
    },
    getReportType() {
      this.$http
        .get("/report-type")
        .then((res) => {
          this.typeReport = res.data.map((report) => {
            return {
              description: report.exhibition_name,
              id: report.id_report_type,
            };
          });
        })
        .catch(() => {
          (this.notification = {
            active: true,
            description: "Houve um erro na solicitação.",
            type: "error",
            closeText: "Fechar",
          }),
            this.$emit("notification", this.notification);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getChannel() {
      this.$http
        .get("/channel/allowed")
        .then((res) => {
          this.channelList = res.data.map((channel) => {
            return {
              name: channel.name,
              id: channel.id_youtube_channel,
            };
          });
        })
        .catch(() => {
          (this.notification = {
            active: true,
            description: "Houve um erro na solicitação.",
            type: "error",
            closeText: "Fechar",
          }),
            this.$emit("notification", this.notification);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    deleteReport() {
      this.$http
        .delete('/report/'+ this.report.id_report)
        .then(() => {
        (this.notification = {
            active: true,
            description: "Relatório excluído com sucesso.",
            type: "success",
            closeText: "Fechar",
        }),
            this.$emit("notification", this.notification);
        })
        .catch(() => {
        (this.notification = {
            active: true,
            description: "Houve um erro ao excluir este Relatório, tente novamente.",
            type: "error",
            closeText: "Fechar",
        }),
            this.$emit("notification", this.notification);
        })
        .finally(() => {
            (this.loading = false),
            (this.valid = true),
            (this.dialog = false),
            (this.deleteConfirm = false),
            this.$emit("getData");
        }
      );
    },
    downloadReport() {
        this.$http.get( '/report/'+this.report.id_report+'/download' )
        .then( ( res ) => {
          window.open(res.data.link, 'download_window');
        } ).catch( () => {
          this.notification = {
            active: true,
            description: 'Houve um erro na solicitação.',
            type: 'error',
            closeText: 'Fechar'
          };
          this.$emit( 'notification', this.notification );
        })
      }
  }
}
</script>